import { LOCAL_STORAGE_KEY, LOCAL_STORAGE_FILTERS_KEY } from 'constants/Global';
import { getPersistedFilters as getAppointmentDashboardFilters } from 'modules/appointments/selectors/dashboard';
import { getPersistedFilters as getAuditsFilters } from 'modules/audits/selectors/dashboard';
import { getFilters as getCamerasFilters } from 'modules/cameras/selectors';
import { getFilters as getCampaignFilters } from 'modules/campaigns/selectors/dashboard';
import { getDetailsFilters as getChatFilters } from 'modules/chat/selectors/details';
import { getFilters as getDeviceFilters } from 'modules/devices/selectors/dashboard';
import { getFiltersState as getFollowUpFilters } from 'modules/followUp/selectors/dashboard';
import { getFilters as getHardwaresFilters } from 'modules/hardwares/selectors';
import { getLocale } from 'modules/i18n/selectors/data';
import { getAllInterventionsFilters } from 'modules/interventions/selectors/dashboard';
import { getFilters } from 'modules/interventions/selectors/kanban';
import { getFilters as getMobilityFilters } from 'modules/interventions/selectors/mobilityDashboard';
import { getFilters as getKiosksFilters } from 'modules/kiosks/selectors';
import { getFilters as getLeadsFilters } from 'modules/leads/selectors/dashboard';
import { getPersistedFilters as getPaymentsFilters } from 'modules/payments/selectors';
import { getPersistedFilters as getSafeDashboardFilters } from 'modules/planning/selectors';
import { getFilters as getReleaseFilters } from 'modules/releases/selectors/dashboard';

import { getUsersFilter } from 'selectors/userSelectors';

const readPersisted = key => {
  try {
    return JSON.parse(localStorage.getItem(key));
  } catch {
    return null;
  }
};

export const getPersistedData = () => readPersisted(LOCAL_STORAGE_KEY);
export const getPersistedFilters = () => readPersisted(LOCAL_STORAGE_FILTERS_KEY);

const setPersistedData = state => {
  const locale = getLocale(state);
  const chat = {};

  const serializedState = JSON.stringify({
    locale,
    chat,
  });

  localStorage.setItem(LOCAL_STORAGE_KEY, serializedState);
};

const setPersistedFilters = state => {
  const filters = {
    kanban: getFilters(state),
    intervention: getAllInterventionsFilters(state),
    appointments: getAppointmentDashboardFilters(state),
    safeCalendar: getSafeDashboardFilters(state),
    users: getUsersFilter(state),
    devices: getDeviceFilters(state),
    leads: getLeadsFilters(state),
    kiosks: getKiosksFilters(state),
    audits: getAuditsFilters(state),
    cameras: getCamerasFilters(state),
    hardwares: getHardwaresFilters(state),
    chat: getChatFilters(state),
    campaigns: getCampaignFilters(state),
    followUpDashboard: getFollowUpFilters(state),
    mobility: getMobilityFilters(state),
    payments: getPaymentsFilters(state),
    releases: getReleaseFilters(state),
  };

  const serializedState = JSON.stringify({ filters });
  localStorage.setItem(LOCAL_STORAGE_FILTERS_KEY, serializedState);
};

export const saveState = state => {
  setPersistedData(state);
  setPersistedFilters(state);
};

export const removeState = (keyToClear = LOCAL_STORAGE_FILTERS_KEY) => localStorage.removeItem(keyToClear);
